import { httpCreate } from './http';

const http = httpCreate('/srv/photoUpload');

export const photoUpload = {
	uploadWater(data) {
		return http.post('/single/waterMark', data);
	}
};
